import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import SearchSvg from '../../svg/admin/Search';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { useSetting } from '../../util/useSetting';
import { fetchUserDataById } from '../../services2/users.service.js';


function Component(props) {
    const { } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get('id');
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(true)
    const [total, settotal] = useState(0)
    const { fontSize } = useSetting();


    const filter = searchParams.get('filter') || '全部';
    const status = searchParams.get('status') || '全部';
    const page = parseInt(searchParams.get('page')) || 1;
    const limit = 10
    const totalPage = Math.ceil(total / limit) || 1

    const handleSelectPage = (p) => async () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    const handleUpdateStatus = (newValue) => {
        searchParams.delete('status')
        searchParams.set('status', newValue)
        setSearchParams(searchParams)
    }


    const [user,setuser]=useState(null)
    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
       let result = await fetchUserDataById(props.token.token)
            if( result.result){
                setuser(result.result)
            }
        setisLoading(false)
    }


    useEffect(() => {
        const timer = setTimeout(() => fetchData(true), 500)
        // const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])



    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex p-[16px] gap-[16px] ' style={{ fontSize, backgroundImage: 'url(/secondary/bg9.png)', backgroundSize: 'contain', backgroundPosition: 'right', backgroundRepeat: 'no-repeat' }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-col items-start justify-start gap-[16px]'>
                <div className='text-[#4B555C] font-[900] ' style={{fontSize: fontSize + 4}}>個人資料</div>
            </div>
            {/*end of title, filter, serach box*/}

            {/*list of data*/}
            <div className='flex flex-row w-full flex-wrap px-[16px] justify-start items-start  overflow-auto gap-[18px] pb-[16px]'>
                <div className='flex flex-col gap-[8px]'>
                    <div className=''>學生姓名</div>
                    <input type="text" value={user?.name || ''} readOnly className='border border-gray-300 rounded p-[8px] bg-[#eee]' />
                </div>

                {/* <div className='flex flex-col gap-[8px]'>
                    <div className=''>性別</div>
                    <div className='flex flex-row gap-[8px] flex-1 items-center py-[4px]'>
                        <input type="checkbox" checked={user?.gender === '男'} readOnly className='border border-gray-300 rounded p-[8px] bg-[#eee]' />
                        男
                        <input type="checkbox" checked={user?.gender === '女'} readOnly className='border border-gray-300 rounded p-[8px] bg-[#eee] ml-[16px]' />
                        女
                    </div>
                </div> */}

                <div className='flex flex-col gap-[8px]'>
                    <div className=''>班級</div>
                    <input type="text" value={user?.class || ''} readOnly className='border border-gray-300 rounded p-[8px] bg-[#eee]' />
                </div>
                <div className='flex flex-col gap-[8px]'>
                    <div className=''>電郵</div>
                    <input type="text" value={user?.username || ''} readOnly className='border border-gray-300 rounded p-[8px] bg-[#eee]' />
                </div>
            </div>
            {/*end of list of data*/}

            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
